import React, { Component, Fragment } from 'react'
import { ApiHelper } from '../../helpers/ApiHelper';
import { css, StyleSheet } from 'aphrodite';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { SEStyles } from './SEStyles';
import { Grid, Card, CardContent, CardActionArea, Tooltip, Paper, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Helper } from '../../helpers/Helper';
import { AppHelper } from '../../../helpers/AppHelper';

export class SubEntityCard extends Component {
  constructor(props) {
    super(props)
    this.fields = this.props.formDefinition.steps[0].fields
  }

  render() {
    const fields = this.generateFields()
    return (
      <div className={css(SEStyles.container)}>
        <div className={css(SEStyles.content)}>
          <div className={css(SEStyles.heading)}>
            <h2 className={css(SEStyles.stepFormTitle)}>{this.props.title}</h2>
            {<Button className={css(SEStyles.editButton)} onClick={() => this.props.openModalForEdit(this.props.item)}>
              Edit
            </Button>}
          </div>
          {fields.map(item => {
            return (
              <div key={item.label}>
                <p className={css(SEStyles.label)}>{item.label}</p>
                <p className={css(SEStyles.value)}>{item.valueDisplay || item.resolvedValue || item.value}</p>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  generateFields() {
    const fields = []
    for (const current of this.fields) {
      const field = {
        id: current.key,
        label: current.label,
        value: this.props.item[current.key],
      }
      if (field.value && current.valueDisplayScale) {
        field.value /= current.valueDisplayScale
      }
      switch (current.type) {
      case 'edit_text':
        break
      case 'rich_text':
        field.valueDisplay = 'YES'
        break
      case 'radio':
      case 'check_box':
        console.log('radio:', field, current)
        if (field.value && current.options) {
          const optionsByKey = {}
          current.options.forEach(i => optionsByKey[i.key] = i)
          let valuesToResolve = field.value
          if (!Array.isArray(valuesToResolve)) {
            valuesToResolve = [valuesToResolve]
          }
          const resolvedValues = []
          valuesToResolve.forEach(i => resolvedValues.push(optionsByKey[i].text))
          field.resolvedValue = resolvedValues.join(', ')
        }
        break
      default:
        continue
      }
      if (!current.placement) {
        current.placement = 'left' // default
      }
      if (!(current.key in this.props.item)) {
        continue
      }
      if (current.placement === 'left') {
        fields.push(field)
      } else if (current.placement === 'right') {
        fields.push(field)
      }
    }
    return fields
  }
}

const Styles = StyleSheet.create({

})


// WEBPACK FOOTER //
// ./src/common/components/SubEntity/SubEntityCard.js